// cache-bust 1778798025.237835
/* Luv Secret : Candle Picker controller   v2 (cart stability fix)
   Owns the interactive picker behaviour:
   - Click a thumbnail to add the candle to cart as a regular line item.
   - Shopify's automatic discount (LUV Free candle with ritual £120+) zeroes it.
   - If cart drops below threshold, the candle is auto-removed.
   - If chosen candle goes OOS at refresh, auto-swap to next available.
*/
(function () {
  'use strict';

  var CANDLE_HANDLES = []; // resolved from picker DOM
  var INTENT_LOCK_MS = 4000;
  var intentLockUntil = 0;
  var inFlight = null; // serialise add / remove / swap

  function getPickers() {
    return document.querySelectorAll('.luv-candle-picker--interactive[data-luv-candle-picker]');
  }

  function resolveCandleHandlesFromDOM() {
    var set = new Set();
    document.querySelectorAll('.luv-candle-picker [data-luv-candle-item]').forEach(function (el) {
      var h = el.getAttribute('data-handle');
      if (h) set.add(h);
    });
    CANDLE_HANDLES = Array.from(set);
  }

  function isCandleHandle(h) {
    return CANDLE_HANDLES.indexOf(h) !== -1;
  }

  function getCurrentCandleInCart(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isCandleHandle(it.handle)) {
        return it;
      }
    }
    return null;
  }

  // Non-candle subtotal at effective (post-line-discount) price.
  // This is what counts toward the £120 candle threshold.
  // v3.4 (2026-06-04) : a PAID candle (final_line_price > 0) still counts. Only
  // the FREE BOGOS candle (final_line_price === 0) is excluded. Otherwise a
  // customer adding a £29 candle to a £100 cart would see the ladder drop
  // instead of advance toward the £120 free-candle tier.
  function nonCandleSubtotal(cart) {
    if (!cart || !cart.items) return 0;
    var sum = 0;
    cart.items.forEach(function (it) {
      var px = (typeof it.final_line_price === 'number') ? it.final_line_price
              : (typeof it.line_price === 'number') ? it.line_price
              : (it.original_line_price || 0);
      if (isCandleHandle(it.handle) && px === 0) {
        // free BOGOS candle : skip
        return;
      }
      sum += px;
    });
    return sum;
  }

  function isAboveCandleThreshold(cart) {
    if (!window.LuvRewards || !cart) return false;
    var t = window.LuvRewards.thresholds();
    return nonCandleSubtotal(cart) >= t.candle;
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addCandle(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function removeCandle(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  function emitUpdate(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('luv:cart-changed', { detail: cart }));
  }

  function paintConfirmed(picker, candleItem) {
    picker.classList.add('is-confirmed');
    var t = picker.querySelector('[data-luv-candle-confirm-text]');
    if (t) {
      var name = candleItem.product_title || candleItem.title || '';
      t.textContent = '\u2713 ' + name.split(':')[0].trim() + ' added \u00b7 Free';
    }
    picker.querySelectorAll('[data-luv-candle-item]').forEach(function (el) {
      el.classList.toggle('is-selected', el.getAttribute('data-handle') === candleItem.handle);
    });
  }

  function paintEmpty(picker) {
    picker.classList.remove('is-confirmed');
    picker.querySelectorAll('[data-luv-candle-item]').forEach(function (el) {
      el.classList.remove('is-selected');
    });
  }

  function lockCopy(cart) {
    try {
      var thr = window.LuvRewards && window.LuvRewards.thresholds ? window.LuvRewards.thresholds() : null;
      if (!thr || !thr.candle) return 'Unlocks at the free candle threshold.';
      var cur = (cart && cart.currency) || 'GBP';
      var sym = cur === 'USD' ? '$' : (cur === 'EUR' ? '\u20AC' : '\u00A3');
      var diff = Math.max(0, thr.candle - nonCandleSubtotal(cart));
      var amt = Math.ceil(diff / 100);
      return 'Add ' + sym + amt + ' more to unlock your free candle.';
    } catch (e) {
      return 'Unlocks at the free candle threshold.';
    }
  }

  function syncAllPickers(cart) {
    var existing = getCurrentCandleInCart(cart);
    var eligible = isAboveCandleThreshold(cart);
    var lockText = eligible ? '' : lockCopy(cart);
    getPickers().forEach(function (picker) {
      if (existing) paintConfirmed(picker, existing);
      else paintEmpty(picker);
      var wrap = picker.closest('.luv-cart-picker');
      if (wrap) {
        wrap.classList.toggle('is-locked', !eligible && !existing);
        var msg = wrap.querySelector('.luv-cart-picker-lock-msg');
        if (!eligible && !existing) {
          if (!msg) {
            msg = document.createElement('p');
            msg.className = 'luv-cart-picker-lock-msg';
            wrap.appendChild(msg);
          }
          msg.textContent = lockText;
          msg.style.display = '';
        } else if (msg) {
          // Clear it so it never lingers stale when threshold is reached
          msg.textContent = '';
          msg.style.display = 'none';
        }
      }
    });
  }

  // Ask the host cart page (Dawn cart-items component) to repaint its lines after
  // we've mutated the cart in the background. Without this the candle line never
  // appears until the user reloads the page.
  function refreshCartPageSections() {
    var hostMci = document.getElementById('main-cart-items');
    var hostMcf = document.getElementById('main-cart-footer');
    var iconHost = document.getElementById('cart-icon-bubble');
    if (!hostMci && !hostMcf && !iconHost) return Promise.resolve();
    function fetchSection(sectionId) {
      if (!sectionId) return Promise.resolve(null);
      return fetch('/cart?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .catch(function () { return null; });
    }
    function replace(hostEl, html, selector) {
      if (!hostEl || !html) return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var found = doc.querySelector(selector);
        if (!found) return;
        var targetInner = hostEl.querySelector(selector);
        if (targetInner) targetInner.innerHTML = found.innerHTML;
      } catch (e) {}
    }
    var jobs = [];
    if (hostMci && hostMci.dataset.id) jobs.push(fetchSection(hostMci.dataset.id).then(function (h) { replace(hostMci, h, '.js-contents'); }));
    if (hostMcf && hostMcf.dataset.id) jobs.push(fetchSection(hostMcf.dataset.id).then(function (h) { replace(hostMcf, h, '.js-contents'); }));
    if (iconHost && iconHost.dataset && iconHost.dataset.id) {
      jobs.push(fetchSection(iconHost.dataset.id).then(function (h) {
        if (!h) return;
        try {
          var doc = new DOMParser().parseFromString(h, 'text/html');
          var bubble = doc.querySelector('#cart-icon-bubble');
          if (bubble) iconHost.innerHTML = bubble.innerHTML;
        } catch (e) {}
      }));
    }
    return Promise.all(jobs);
  }

  function lockIntent() { intentLockUntil = Date.now() + INTENT_LOCK_MS; }
  function intentLocked() { return Date.now() < intentLockUntil; }

  function serialise(taskFactory) {
    var run = function () {
      var p;
      try { p = Promise.resolve(taskFactory()); }
      catch (e) { p = Promise.reject(e); }
      return p;
    };
    if (inFlight) {
      inFlight = inFlight.then(run, run);
    } else {
      inFlight = run();
    }
    var current = inFlight;
    current.finally(function () { if (inFlight === current) inFlight = null; }).catch(function(){});
    return current;
  }

  function handleClick(e) {
    var item = e.target.closest('[data-luv-candle-item]');
    if (!item) return;
    if (item.classList.contains('is-oos')) return;
    var picker = item.closest('.luv-candle-picker--interactive');
    if (!picker) return;
    var variantId = parseInt(item.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    // Stop the click from being interpreted as "click outside" by parent components
    // (cart-notification.handleBodyClick closes the popup when target is outside it).
    e.stopPropagation();
    if (typeof e.preventDefault === 'function') e.preventDefault();

    lockIntent();
    serialise(function () {
      return refreshCart().then(function (cart) {
        var existing = getCurrentCandleInCart(cart);
        var eligible = isAboveCandleThreshold(cart);

        // Same candle clicked again : toggle it off so the user can change their mind.
        if (existing && existing.variant_id === variantId) {
          return removeCandle(existing.key);
        }

        // Picked a different candle : swap.
        if (existing && existing.variant_id !== variantId) {
          if (!eligible) {
            // Eligibility check should treat the cart as if the current candle didn't exist
            // (it doesn't count toward the threshold). nonCandleSubtotal already excludes it,
            // so reaching here means truly below threshold.
            flash(picker);
            return null;
          }
          return removeCandle(existing.key).then(function () { return addCandle(variantId); });
        }

        // No candle yet, but eligible : add it.
        if (!existing && eligible) {
          return addCandle(variantId);
        }

        // Not eligible and nothing in cart : visually flash, no mutation.
        flash(picker);
        return null;
      })
      .then(function () { return refreshCart(); })
      .then(function (cart) {
        if (!cart) return;
        window.__luvCart = cart;
        emitUpdate(cart);
        syncAllPickers(cart);
        // Repaint cart page sections so the candle line item appears/disappears.
        return refreshCartPageSections();
      })
      .catch(function () {});
    });
  }

  function flash(picker) {
    picker.classList.add('is-flash');
    setTimeout(function () { picker.classList.remove('is-flash'); }, 800);
  }

  function handleChange(e) {
    var btn = e.target.closest('[data-luv-candle-change]');
    if (!btn) return;
    e.stopPropagation();
    if (typeof e.preventDefault === 'function') e.preventDefault();
    lockIntent();
    serialise(function () {
      return refreshCart().then(function (cart) {
        var existing = getCurrentCandleInCart(cart);
        if (!existing) {
          // Already empty : just unconfirm visually so the grid reappears.
          getPickers().forEach(paintEmpty);
          return null;
        }
        return removeCandle(existing.key);
      })
      .then(function () { return refreshCart(); })
      .then(function (cart) {
        if (!cart) return;
        window.__luvCart = cart;
        emitUpdate(cart);
        syncAllPickers(cart);
        return refreshCartPageSections();
      })
      .catch(function () {});
    });
  }

  function maybeAutoRemoveBelowThreshold() {
    refreshCart().then(function (cart) {
      window.__luvCart = cart;
      var candle = getCurrentCandleInCart(cart);
      if (candle && !isAboveCandleThreshold(cart)) {
        removeCandle(candle.key).then(function () {
          refreshCart().then(function (cart2) {
            window.__luvCart = cart2;
            emitUpdate(cart2);
            syncAllPickers(cart2);
            refreshCartPageSections();
          });
        });
      } else {
        syncAllPickers(cart);
      }
    });
  }

  function init() {
    resolveCandleHandlesFromDOM();
    // Capture-phase so we run before cart-notification's body-click close handler.
    document.addEventListener('click', handleClick, true);
    document.addEventListener('click', handleChange, true);

    var onCartChange = function (e) {
      var detail = (e && e.detail) ? e.detail : null;
      var cart = detail && detail.data ? detail.data : detail;
      var src = (detail && detail.sourceId) || '';
      var done = function (c) {
        window.__luvCart = c;
        resolveCandleHandlesFromDOM();
        var candle = getCurrentCandleInCart(c);
        // Don't yank the candle we just added : skip auto-remove during the intent lock.
        if (candle && !isAboveCandleThreshold(c) && !intentLocked()) {
          removeCandle(candle.key).then(function () {
            refreshCart().then(function (c2) {
              window.__luvCart = c2;
              syncAllPickers(c2);
              document.dispatchEvent(new CustomEvent('luv:cart-changed', { detail: c2 }));
              refreshCartPageSections();
            });
          });
        } else {
          syncAllPickers(c);
          // If this update came from our own candle add/remove (sourceId 'luv-candle-picker') or
          // from any /cart/* call originating in our flow, repaint cart page sections so the
          // candle line item shows up without a full reload.
          // We trigger this on every cart-sync-broadcast update so the cart page stays consistent.
          if (src === 'luv-cart-sync' || src === 'fetch' || src === 'xhr' || src === 'cart-notification') {
            refreshCartPageSections();
          }
        }
      };
      if (cart && cart.items) {
        done(cart);
      } else {
        refreshCart().then(function (c) { if (c) done(c); });
      }
    };
    document.addEventListener('cart:update', onCartChange);
    document.addEventListener('cart:updated', onCartChange);

    refreshCart().then(function (cart) {
      window.__luvCart = cart;
      syncAllPickers(cart);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.LuvCandlePicker = {
    refresh: function () { return refreshCart().then(function (cart) { window.__luvCart = cart; syncAllPickers(cart); return refreshCartPageSections().then(function(){ return cart; }); }); },
    maybeAutoRemoveBelowThreshold: maybeAutoRemoveBelowThreshold,
    isAboveCandleThreshold: isAboveCandleThreshold,
    getCurrentCandleInCart: getCurrentCandleInCart,
    nonCandleSubtotal: nonCandleSubtotal
  };
})();

/* edge-rotate-touch 1780610980 */
